// // 字段排序函数
// const compare = property => {
//   return function (a, b) {
//     var value1 = a[property];
//     var value2 = b[property];
//     return value1 - value2;
//   };
// };

// // 获取排序后的列表
// export const orderProductList = state => {
//   return state.productList.sort(compare(state.orderBy));
// };

// 购物车总数量
export const getShoppingCartTotal = state => {
  let total = 0;
  state.shoppingCart.forEach((item) => { total += item.Quantity; });
  return total;
};



// WEBPACK FOOTER //
// ./src/vuex/getters.js